<script>
import Form from '../../../../../components/form';
import request from '../../../../../utils/request';

export default {
  extends: Form,
  components: {},
  data() {
    return {
      rule: [],
      formFunctionCode: 'kms_sold_to_party_form',
    };
  },
  methods: {
    // 对rule进行处理
    beforeSetRule(rule) {
      return rule;
    },
    // 单个rule处理
    setRule(v) {
      const item = v;
      if (item.field === 'remarks') {
        item.props = {
          ...item.props,
          type: 'textarea',
        };
      }
      if (item.field === 'directSystemId') {
        item.restful = '/mdm/mdmDirectSystemController/directSystemSelect';
        item.restfulParams = {
          enableStatus: '009',
        };
        item.optionsKey = { label: 'directSystemName', value: 'directSystemId' };
        item.props = {
          ...item.props,
          filterable: true,
          remote: true,
          remoteParams: 'directSystemName',
        };
      }
      if (item.field === 'sellPartyCode') {
        item.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[a-zA-Z0-9]*$',
            message: '仅能输入英文和数字的组合',
          },
        ];
      }
      return item;
    },
    // 表单渲染完成后回调
    formComplete() {
      this.setValue({
        enableStatus: '009',
      });
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        this.setValue(this.formConfig.row);
      }
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/mdmSellPartyController/save';
        const params = { ...formData };

        if (this.formConfig.code === 'edit') {
          url = '/mdm/mdmSellPartyController/update';
          params.id = this.formConfig.row.id;
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
</script>
